module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_LT-53dea785ec45946f7071fa62434af43c.svg";